import { format, intervalToDuration } from 'date-fns'

const isoFormat = 'yyyy-MM-dd'

function _setDarkTheme() {
    document.documentElement.classList.add('dark')
    localStorage.theme = 'dark'
}

function _setWhiteTheme() {
    document.documentElement.classList.remove('dark')
    localStorage.theme = 'white'
}

function changeTheme() {
    if (localStorage.theme === 'dark') {
        _setWhiteTheme()
    } else {
        _setDarkTheme()
    }
}

function setCurrentTheme() {
    if (localStorage.theme === 'dark') {
        _setDarkTheme()
    } else {
        _setWhiteTheme()
    }
}

function isThemeDark() {
    return localStorage.theme === 'dark'
}

function checkFormValidity(formData) {
    return Object.keys(formData).every(name => !formData[name].hasOwnProperty('valid') || formData[name].valid)
}

function collectFormData(formData) {
    return Object.keys(formData).reduce((data, name) => {
        data[name] = formData[name].value
        return data
    }, {})
}

function clearFormData(formData) {
    return Object.keys(formData).reduce((data, name) => {
        data[name] = {
            value: null,
            valid: true
        }

        return data
    }, {})
}

function changeItemsAfterUpdate(items, updatedItem, searchId = 'id') {
    const index = items.findIndex(item => item[searchId] === updatedItem[searchId])

    if (index !== null && index > -1) {
        items[index] = Object.assign({}, items[index], updatedItem)
    }

    return items
}

function currency(value = 0, currency = 'USD', minimumFractionDigits = 2) {
    return new Intl.NumberFormat('en-US',{
        style: 'currency',
        minimumFractionDigits,
        currency
    }).format(isNaN(value) ? 0 : +value)
}

function parseCredentials(credentials, id, updatedItem, fieldName = 'credentials') {
    return JSON.parse(credentials).reduce((obj, item) => {
        obj[item.key] = {
            value: !!id ? updatedItem[fieldName][item.key] : null,
            valid: true,
            label: item.label,
        }

        return obj
    }, {})
}

function getFullTimeNumber(number) {
    const str = `${number}`

    return str.length === 1 ? `0${str}` : str
}

function randomID(length = 16) {
    return parseInt(Math.ceil(Math.random() * Date.now()).toPrecision(length).toString().replace(".", ""))
}

function localSearch(items, search, searchFieldNames) {
    if (!search) {
        return items
    }

    return items.filter(item => searchFieldNames.some(name => item[name].toString().toLowerCase().includes(search.toLowerCase())))
}

function calculateTotalPages(items, onPage) {
    return Math.max(Math.ceil(items.length / onPage), 1)
}

function localSort(items, sortBy, isDesc, type) {
    if (!sortBy) {
        return items
    }

    return copyArray(items).sort((a, b) => _customSorting(a[sortBy], b[sortBy], isDesc, type))
}

function _customSorting(a, b, desc, type) {
    switch (type) {
        case 'boolean':
            return _booleanSorting(a, b, desc)
        case 'number':
            return _numericSorting(a, b, desc)
        case 'time':
            return _timeSorting(a, b, desc)
        case 'date':
            return _dateSorting(a, b, desc)
        case 'status':
            return _numericSorting(a, b, !desc)
        default:
            return _stringSorting(a, b, desc)
    }
}

function _stringSorting(a, b, desc) {
    return desc ? `${b}`.toLowerCase().localeCompare(`${a}`.toLowerCase()) : `${a}`.toLowerCase().localeCompare(`${b}`.toLowerCase())
}

function _numericSorting(a, b, desc) {
    return desc ? b - a : a - b
}

function _booleanSorting(a, b, desc) {
    return desc ? Number(b) - Number(a) : Number(a) - Number(b)
}

function _timeSorting(a, b, desc) {
    const timeA = _calcTime(a)
    const timeB = _calcTime(b)

    return desc ? timeB - timeA : timeA - timeB
}

function _dateSorting(a, b, desc) {
    return desc ? new Date(b) - new Date(a) : new Date(a) - new Date(b)
}

function _calcTime(time) {
    const arr = time.split(':')

    return (arr[0] * 60 * 60) + (arr[1] * 60) + arr[2]
}

function copyArray(arr) {
    return JSON.parse(JSON.stringify(arr))
}

function preventDefaults (e) {
    e.preventDefault()
    e.stopPropagation()
}

function downloadFile(response) {
    const fileName = response.headers['content-disposition'].split('=')[1]
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
}

function upFirstLetter(str) {
    return `${str[0].toUpperCase()}${str.slice(1)}`
}


function formatDuration(seconds) {
    const duration = intervalToDuration({ start: 0, end: seconds * 1000 })
    const str = `${duration.hours}:${duration.minutes}:${duration.seconds}`
    return str.split(':').map(i => {
        return i = `${i}`.length === 1 ? `0${i}` : i
    }).join(':')
}

function defaultFormatDate(date) {
    return format(new Date(date), isoFormat)
}

export { defaultFormatDate, changeTheme, setCurrentTheme, isThemeDark, checkFormValidity, collectFormData, clearFormData, changeItemsAfterUpdate, currency, parseCredentials, getFullTimeNumber, randomID, localSearch, calculateTotalPages, localSort, preventDefaults, downloadFile, upFirstLetter, formatDuration }
